import React, { useState, useEffect } from 'react';
import { Card, Typography, Flex, Badge } from 'antd';
import ReactPlayer from 'react-player';
import ItemCard from './ListCard';
import VideoCard from './VideoCard';
const { Title, Text, Paragraph } = Typography;

interface ListItemProps {
  item: any;
  selectedTab: string;
  isNewsletter?: boolean;
  includeDateInHeading?: boolean;
  playingVideoId?: string | null;
  priority?: 'oldest' | 'newest' | 'mostrelevant';
  hasNoSidebar?: boolean;
  onReadMoreClick: (title: string, url: string, isPdfDownloadAble?: boolean) => void;
  onPlayClick?: (title: string, url: string, id: string) => void;
  onVideoPlay?: (isPlaying: string | null, title: string) => void;
  onVideoEnd?: (isPlaying: string | null, title: string) => void;
  onNewsletterClick?: (title: string,url: string, isNewsArticleDownloadAble?: boolean) => void;
}

const ListItem: React.FC<ListItemProps> = ({
  item,
  selectedTab,
  onReadMoreClick,
  isNewsletter,
  includeDateInHeading,
  priority,
  onVideoPlay,
  onPlayClick,
  onVideoEnd,
  onNewsletterClick,
  playingVideoId,
  hasNoSidebar,
}) => {
  if (selectedTab === 'video') {
    return (
      <VideoCard
        hasNoSidebar={hasNoSidebar}
        playingVideoId={playingVideoId || null}
        id={item.id}
        title={item.title}
        description={item.description}
        date={item.date}
        videoURL={item.videoURL}
        onVideoPlay={(isPlaying: string | null) => {
          onVideoPlay && onVideoPlay(isPlaying, item.title);
        }}
        onVideoEnd={(isPlaying: string | null) => {
          onVideoEnd && onVideoEnd(isPlaying, item.title);
        }}
      />
    );
  }
  
  return (
    <ItemCard
      id={item.id}
      title={item.title}
      description={item.description}
      date={item.date}
      pdfURL={item.pdfURL}
      videoURL={item.videoURL}
      articleURL={item?.articleURL}
      isPdfDownloadAble={item?.isPdfDownloadAble}
      isNewsArticleDownloadAble={item?.isNewsArticleDownloadAble}
      onReadMoreClick={onReadMoreClick}
      onPlayClick={onPlayClick}
      onNewsletterClick={onNewsletterClick}
      includeDateInHeading={includeDateInHeading}
    />
  );
};

export default ListItem;
